import { render, staticRenderFns } from "./ForumArticle.vue?vue&type=template&id=365e381f&"
import script from "./ForumArticle.vue?vue&type=script&lang=js&"
export * from "./ForumArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports